import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { Credit } from 'src/app/shared/models/credit.model';
import { CreditFilter } from '../../models/creditFilter.model';
import { FinancialObs } from '../../models/financialObs.model';
import { UtilService } from '../../architecture/services/util.service';
import { Approval } from '../../models/approval.model';
import { UpdateFollowUp } from '../../models/updateFollowUp.model';

@Injectable({ providedIn: 'root' })
export class CreditService {
    constructor(private dataService: DataService,
        private utilService: UtilService,
    ) { }

    public get(page: number, order: string, orderT: string, filter: CreditFilter) {
        let body = {
            entity: {
                id: String(filter.id),
                bank: filter.bank,
                frontOffice: filter.frontOffice,
                negRef: filter.negRef,
                startForecast: filter.startForecast,
                endForecast: filter.endForecast,
                startRelease: filter.startRelease,
                endRelease: filter.endRelease,
            },
            page: page,
            orderByField: order,
            orderBy: orderT,
        };

        return this.dataService.post<Result<Credit>>('credit', body);
    }

    public report(filter: CreditFilter) {
        let body = {
            entity: {
                id: String(filter.id),
                bank: filter.bank,
                frontOffice: filter.frontOffice,
                negRef: filter.negRef,
                startForecast: filter.startForecast,
                endForecast: filter.endForecast,
                startRelease: filter.startRelease,
                endRelease: filter.endRelease
            }
        };

        this.utilService.DownloadFile("credit/generatefile", "creditos.xlsx", body);
    }

    public setHistory(filter: CreditFilter) {
        let body = {
            id: String(filter.id),
            bank: filter.bank,
            frontOffice: filter.frontOffice,
            negRef: filter.negRef,
            startForecast: filter.startForecast,
            endForecast: filter.endForecast,
            startRelease: filter.startRelease,
            endRelease: filter.endRelease
        };

        return this.dataService.put<Result<FinancialObs>>('credit/history', body);
    }

    public sendApproval(approval: Approval) {
        let body = {
            id: String(approval.id),
            bankId: approval.bankId,
            sitCred: approval.sitCred,
            obs: approval.obs,
            file: approval.file,
            quantity: approval.quantity,
            initQuantity: approval.initQuantity,
            endDate: approval.endDate,
            approval: approval.approval,
        };

        return this.dataService.post<Result>('credit/approval', body);
    }

    public updateFollowUp(updateFollowUp: UpdateFollowUp) {
        let body = {
            id: String(updateFollowUp.id),
            financType: updateFollowUp.financType,
            situation: updateFollowUp.situation,
            quantity: updateFollowUp.quantity,
            obs: updateFollowUp.obs,
            bankId: updateFollowUp.bankId,
            file: updateFollowUp.file,
            initQuantity: updateFollowUp.initQuantity,
            initSitCred: updateFollowUp.initSitCred,
            approval: updateFollowUp.approval,
        };

        return this.dataService.post<Result>('credit/updatefollowup', body);
    }

    public updateObs(obs: FinancialObs) {
        return this.dataService.put<Result<FinancialObs>>('credit/obs', obs);
    }

    public getCreditSit() {
        return this.dataService.get<Result<FinancialObs>>('creditsituation');
    }
}
 